import { NominationAbstract } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationAbstract: (
  fetchContext: FetchContext,
  nominationId: number,
  abstract: string,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, abstract, accessToken) => {
  const nominationAbstract: NominationAbstract = { nominationId, abstract };
  return fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/abstract`, {
    method: 'PUT',
    body: JSON.stringify(nominationAbstract),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination abstract'));
};
